export const createBemFn =
    (block: string) =>
    (element?: string, modifier?: string): string =>
        `${block}${element ? `__${element}` : ""}${modifier ? `--${modifier}` : ""}`;
